module.exports = __webpack_public_path__ + "static/media/cdo.1644e3ea.png";